import { ModelEvent } from 'src/broadcast/Events';
import { RequestUpdatedByCustomerBroadcast } from './RequestUpdatedByCustomerEvent.types';

class RequestUpdatedByCustomerEvent extends ModelEvent<RequestUpdatedByCustomerBroadcast> {
  public namespace = '.App\\Events\\Request\\RequestUpdatedByCustomer';
}

export default RequestUpdatedByCustomerEvent;
